import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Tooltip, Drawer, List, ListItem, Box, Typography } from '@mui/material';
// Icons
import homeIcon from '../../assets/icons/icon_home.svg';
import homeIconDisabled from '../../assets/icons/disabled/icon_home_disabled.svg';
import buildingIcon from '../../assets/icons/icon_building.svg';
import buildingIconDisabled from '../../assets/icons/disabled/icon_building_disabled.svg';

const Sidebar = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { solicitudesContrato, prestadorSesion, consultorioDetail, solicitudDetail } =
    useContext(AgendaContext);
  const routesWithSidebar = [
    '/prestador/dashboard',
    '/prestador/misConsultorios',
    `/prestador/misConsultorios/${consultorioDetail?.consultorioOsde[0].consultorioId}`,
    `/prestador/solicitud/${solicitudDetail?.id}`
  ];
  const showSidebar = routesWithSidebar.includes(location.pathname);

  useEffect(() => {
    setMenuFocus(location.pathname);
  }, [location.pathname]);

  const [menuFocus, setMenuFocus] = useState(location.pathname);

  const hasFocus = (path) => menuFocus.includes(path);

  const toggleDrawer = () => setOpen(!open);

  const handleRedirectMisConsultorios = () => {
    open ? navigate('/prestador/misConsultorios') : null;
  };

  const handleRedirectInicio = () => {
    open ? navigate('/prestador/dashboard') : null;
  };

  const boxInicio = (
    <Box
      onClick={() => handleRedirectInicio()}
      sx={{
        minWidth: '3rem',
        gap: '1.5rem',
        width: '100%',
        borderRadius: '0.5rem',
        padding: '0.75rem',
        backgroundColor:
          hasFocus('dashboard') || hasFocus('solicitud')
            ? theme.palette.backgroundSecondary.main
            : theme.palette.white.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.backgroundSecondary.main
        }
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          width: '1.5rem',
          height: '1.5rem'
        }}>
        {hasFocus('dashboard') || hasFocus('solicitud') ? (
          <Box
            component="img"
            sx={{ width: '24px', height: '24px' }}
            alt="img not found"
            src={homeIcon}
          />
        ) : (
          <Box
            component="img"
            sx={{ width: '24px', height: '24px' }}
            alt="img not found"
            src={homeIconDisabled}
          />
        )}
      </Box>
      {open && (
        <Typography variant="h5" sx={{ color: theme.palette.gray.main }}>
          Inicio
        </Typography>
      )}
    </Box>
  );

  const boxMisConsultorios = (
    <Box
      onClick={() => handleRedirectMisConsultorios()}
      sx={{
        minWidth: '3rem',
        gap: '1.5rem',
        width: '100%',
        maxHeight: '3rem',
        borderRadius: '0.5rem',
        padding: '0.75rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        backgroundColor: hasFocus('misConsultorios')
          ? theme.palette.backgroundSecondary.main
          : theme.palette.white.main,
        '&:hover': {
          backgroundColor: theme.palette.backgroundSecondary.main
        },
        display:
          prestadorSesion?.consultorios?.some(
            (consultorio) =>
              consultorio.status === 'INTEROPERANDO' || consultorio.status === 'PENDIENTE'
          ) ||
            !solicitudesContrato?.every(
              (solicitudes) => solicitudes.status === 'RECHAZADO' || solicitudes.status === 'ANULADO'
            )
            ? 'flex'
            : 'none'
      }}>
      {hasFocus('misConsultorios') ? (
        <Box
          component="img"
          sx={{ width: '24px', height: '24px' }}
          alt="img not found"
          src={buildingIcon}
        />
      ) : (
        <Box
          component="img"
          sx={{ width: '24px', height: '24px' }}
          alt="img not found"
          src={buildingIconDisabled}
        />
      )}
      {open && (
        <Typography
          variant="h5"
          component="p"
          sx={{ color: theme.palette.gray.main, whiteSpace: 'nowrap', overflow: 'hidden' }}>
          Mis consultorios
        </Typography>
      )}
    </Box>
  );

  const navigate = useNavigate();

  return (
    showSidebar && (
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: open ? '15.6rem' : '4rem',
          height: '100%',
          position: 'absolute',
          '& .MuiDrawer-paper': {
            width: open ? '15.6rem' : '4rem',
            flexShrink: 0,
            height: '100%',
            boxSizing: 'border-box',
            transition: 'width 0.3s',
            position: 'fixed',
            marginTop: '76px',
            zIndex: 5,
            borderRight: 'none',
            boxShadow: '5px 8px 10px 0px #0000001A'
          }
        }}>
        <List>
          <ListItem sx={{ justifyContent: open ? 'flex-start' : 'center' }} onClick={toggleDrawer}>
            {!open ? (
              <Tooltip title="Inicio" placement="right">
                {boxInicio}
              </Tooltip>
            ) : (
              boxInicio
            )}
          </ListItem>
          <ListItem sx={{ justifyContent: open ? 'flex-start' : 'center' }} onClick={toggleDrawer}>
            {!open ? (
              <Tooltip title="Mis consultorios" placement="right">
                {boxMisConsultorios}
              </Tooltip>
            ) : (
              boxMisConsultorios
            )}
          </ListItem>
        </List>
      </Drawer>
    )
  );
};

export default Sidebar;
